import 'babel-polyfill';
import { startAppClient } from './init/client';
import { Root } from './components/Root';
import components from 'reducers';
import rootSaga from 'sagas';

import './styles/index.scss';

startAppClient({ RootComponent: Root, componentsReducer: components, rootSaga });
